var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIcnEditLight(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_3231_81057)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M14.34 1.65975C14.1281 1.44871 13.8764 1.28175 13.5996 1.16851C13.3227 1.05528 13.0262 0.998027 12.7271 1.00005C12.428 1.00208 12.1323 1.06334 11.857 1.18031C11.5817 1.29728 11.3323 1.46763 11.1232 1.68153L2.1013 10.7035L1 14.9998L5.29631 13.8979L14.3183 4.87592C14.5322 4.66694 14.7026 4.41763 14.8196 4.14239C14.9366 3.86715 14.9979 3.57145 14.9999 3.27238C15.002 2.97331 14.9447 2.6768 14.8314 2.40001C14.7182 2.12321 14.5511 1.87161 14.34 1.65975V1.65975Z",
    stroke: "white",
    strokeWidth: 1.33,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M10.866 1.93945L14.0604 5.13384",
    stroke: "white",
    strokeWidth: 1.33,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2.10181 10.7021L5.29931 13.8941",
    stroke: "white",
    strokeWidth: 1.33,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_3231_81057"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 16,
    height: 16,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcnEditLight);
export default __webpack_public_path__ + "static/media/icn_edit_light.426a5d386a8307e31601d99ed8acefce.svg";
export { ForwardRef as ReactComponent };